import React from 'react'
import {observer, inject} from 'mobx-react';
import {
    Button,
    CircularProgress,
    TextField,
    Container,
    Snackbar,

} from "@material-ui/core";
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const styles = {
    container: {
        width: '100vw',
        color: '#4a4a4a',
        display: 'flex',
        minHeight: '100vh',
        justifyContent: 'center'
    },
    loader: {
        margin: 'auto',
    },
    main: {
        width: '85vw',
        // margin: 'auto'
    },
    button: {
        borderRadius: '8px',
        height: '3em',
        fontWeight: 'normal',
        fontSize: '0.9em',
        textTransform: 'none',
        color: '#fff',
        backgroundColor: '#ee6a62',
    },
    studioTitle: {
        fontSize: '1.5em',
        fontWeight: '500',
        marginTop: '40px',
        marginBottom: '10px'
    },
    roomTitle: {
        fontSize: '0.9em',
        color: '#4a4a4a',
        marginBottom: '28px'
    },
    textarea: {
        borderColor: '#ee6a62',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        borderRadius: '8px',
        width: '100%',
        margin: '1em 0'
    },
};

const FeedbackIndex = inject('feedbackStore')(observer(({feedbackStore}) => {
        feedbackStore.load();
        return (
            <Container style={styles.container} className="feedback-room-root">
                {feedbackStore.loading ?
                    <CircularProgress color="secondary" style={styles.loader}/> :
                    <div className="feedback-room-main" style={styles.main}>
                        <div className="studio-title">
                            <div>
                                <div style={styles.studioTitle}>{feedbackStore.studio}</div>
                                <div style={styles.roomTitle}>{feedbackStore.room}</div>
                            </div>
                        </div>
                        <div>
                            <Rating
                                name="rating-stars"
                                className="rating-stars"
                                defaultValue={feedbackStore.rating}
                                disabled={feedbackStore.rating}
                                emptyIcon={<StarBorderIcon fontSize="inherit"/>}
                                onChange={feedbackStore.ratingChanged}
                                size="large"/>
                            {!feedbackStore.rating ?
                                <TextField
                                    style={styles.textarea}
                                    placeholder="Поделитесь с музыкантами, почему вам понравилась эта студия"
                                    multiline
                                    onChange={feedbackStore.commentChanged}
                                    className="rates-textarea"
                                    inputProps={{'aria-label': 'description'}}
                                    rows="5"
                                    variant="outlined"
                                />
                                :
                                <div style={styles.roomTitle}>
                                    {feedbackStore.showComment ? feedbackStore.comment : 'Вы уже оставляли отзыв на эту студию'}
                                </div>}
                        </div>
                        {!feedbackStore.rating ?
                            <Button variant="contained"
                                    onClick={feedbackStore.saveFeedback}

                                    style={styles.button}
                            >
                                Отправить
                            </Button>
                            : ''}
                    </div>
                }
                <Snackbar
                    open={feedbackStore.openAlert}
                    autoHideDuration={7000}
                    style={styles.snackbar}
                    onClose={feedbackStore.handleCloseAlert}
                >
                    <Alert severity={feedbackStore.alertMessageType} onClose={feedbackStore.handleCloseAlert}>
                        {feedbackStore.alertMessage}
                    </Alert>
                </Snackbar>
            </Container>

        );
    }
));

export default FeedbackIndex
